const updateNonLocaleUrlsToUrlsWithLocale = (html: string, locale: string): string => {
    const regex = new RegExp(`href="(?!\\/${locale}\\/)(\\/[^"]*)"`, 'g');
    console.log(html.replace(regex, `href="/${locale}$1"`));
    return html.replace(regex, `href="/${locale}$1"`);
};

export { updateNonLocaleUrlsToUrlsWithLocale };